<template>
    <td-dialog
        :title="this.$t('userInfo.DETAIL')"
        :before-close="userDetailDialogClose"
        :visible.sync="dialogUserDetailVisible"
        width="610px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
        :append-to-body="appendToBody"
    >
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane :label="$t('userInfo.BASIC_INFO')" name="first">
                <div>
                    <table style="width: 100%" class="authTable">
                        <tr v-for="(item, index) in basicTableData" :key="index">
                            <td class="authTableLable">{{ item.lable }}</td>
                            <td class="authTableValue">{{ item.value }}</td>
                        </tr>
                    </table>
                </div>
                <div>
                    <table style="width: 100%" class="authTable">
                        <tr v-for="(item, index) in macTableData" :key="index">
                            <td class="authTableLable">{{ item.lable }}</td>
                            <td class="authTableValue">{{ item.value }}</td>
                        </tr>
                    </table>
                </div>
                <div>
                    <table style="width: 100%" class="authTable">
                        <tr v-for="(item, index) in ipTableData" :key="index">
                            <td class="authTableLable">{{ item.lable }}</td>
                            <td class="authTableValue">{{ item.value }}</td>
                        </tr>
                    </table>
                </div>
                <!-- 定义时间段白名单 -->
                <div>
                    <table style="width: 100%" class="authTable">
                        <tr v-for="(item, index) in timeTableData" :key="index">
                            <td class="authTableLable">{{ item.lable }}</td>
                            <td class="authTableValue">{{ item.value }}</td>
                        </tr>
                    </table>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('userInfo.ROLE_INFO')" name="roleInfo">
                <el-row v-if="roleArray.length != 0" style="margin-bottom:10px;">
                    <el-col :span="1">
                        <div class="userInfoTitle"></div>
                    </el-col>
                    <el-col :span="23">
                        <div>{{ $t('role.COMMON_ROLE') }}</div>
                    </el-col>
                </el-row>
                <el-row class="userBackInfo" style="margin-bottom:20px;" v-if="roleArray.length != 0">
                    <div v-for="(item, index) in roleArray" :key="index" class="userSingelRoleDetail">
                        <div class="userRoleModuleInfo" :title="item">
                            {{ item }}
                        </div>
                        <div v-if="index != roleArray.length - 1 && (index + 1) % 4 != 0" class="userdivider"></div>
                    </div>
                </el-row>
                <el-row style="margin-bottom:10px;" v-if="checkedOrgList.length != 0">
                    <el-col :span="1">
                        <div class="userInfoTitle"></div>
                    </el-col>
                    <el-col :span="23">
                        <div>{{ $t('role.ORG_ROLE') }}</div>
                    </el-col>
                </el-row>
                <el-row class="userBackInfo" style="margin-bottom:20px;" v-if="checkedOrgList.length != 0">
                    <div v-for="(item, index) in checkedOrgList" :key="index" class="userSingelRoleDetail">
                        <div class="userRoleModuleInfo" :title="item">
                            {{ item }}
                        </div>
                        <div v-if="index != checkedOrgList.length - 1 && (index + 1) % 4 != 0" class="userdivider"></div>
                    </div>
                </el-row>
                <el-row style="margin-bottom:10px;" v-if="doorAuthList.length != 0">
                    <el-col :span="1">
                        <div class="userInfoTitle"></div>
                    </el-col>
                    <el-col :span="23">
                        <div>{{ $t('role.DOOR_ROLE') }}</div>
                    </el-col>
                </el-row>
                <el-row class="userBackInfo" style="margin-bottom:20px;" v-if="doorAuthList.length != 0">
                    <div v-for="(item, index) in doorAuthList" :key="index" class="userSingelRoleDetail">
                        <div class="userRoleModuleInfo" :title="item">
                            {{ item }}
                        </div>
                        <div v-if="index != doorAuthList.length - 1 && (index + 1) % 4 != 0" class="userdivider"></div>
                    </div>
                </el-row>
                <div v-if="roleArray.length == 0 && checkedOrgList.length == 0 && doorAuthList.length == 0" style="width:200px;height:200px;">
                    <img :src="noData" style="position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);" />
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('userInfo.AUTH_INFO')" name="authInfo">
                <table style="width: 100%;height:450px;overflow:auto;display:block;" class="authTable">
                    <tr v-for="(item, index) in authInfoData" :key="index">
                        <td class="authTableLable">{{ item.lable }}</td>
                        <td class="authTableValue">{{ item.value }}</td>
                    </tr>
                </table>

                <div v-if="authInfoData.length == 0">
                    <img :src="noData" style="position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);" />
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('userInfo.HAVE_AUTH_REF')" name="haveAuthRef">
                <el-form :model="formHaveAuthRef" ref="formHaveAuthRef" :rules="rules" style="padding-top:0px;">
                    <el-row>
                        <el-form-item :label="$t('userInfo.REF_NAME')" prop="refName">
                            <td-input v-model="formHaveAuthRef.refName" :maxlength="30"></td-input>
                            <td-button @click="refBtnQuery()" type="primary" style="margin-left:10px;">{{ $t('common.QUERY') }}</td-button>
                        </el-form-item>
                    </el-row>
                </el-form>
                <td-table
                    ref="refTable"
                    :columns="columns"
                    :dataSource="refTableData"
                    :pageSize="pageSize"
                    :currentPage="currentPage"
                    :total="total"
                    :hasMutiSelect="false"
                    @handleSizeChange="handleSizeChange"
                    @currentChange="currentChange"
                    height="300px"
                    rowKey="sResId"
                ></td-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('userInfo.EXTEND_INFO')" name="extendInfo">
                <el-form :model="formUserInfo" ref="formUserInfo" :rules="rules" style="padding-top:0px;padding-bottom:0px;">
                    <el-row v-for="extend in userExtends" :key="extend.sModuleId" style="padding-top:5px;padding-bottom:5px;">
                        <el-row class="userBackInfo" style="padding-top:20px;padding-left:20px;">
                            <el-col :span="1">
                                <div class="userInfoTitle"></div>
                            </el-col>
                            <el-col :span="23">
                                <div>{{ extend.sModuleName }}</div>
                            </el-col>
                        </el-row>
                        <el-row class="userBackInfo authMsg" style="padding-left:30px;">
                            <div v-for="item in extend.extendList" :key="item.sId">
                                <el-col :span="item.sExtendType === 'checkboxgroup' ? 24 : 12">
                                    <el-form-item :key="item.sId" :label-width="item.sExtendType === 'checkboxgroup' ? '15%' : formLabelWidth" :label="item.sName">
                                        <div v-if="item.sExtendType === 'input' || item.sExtendType === 'combobox' || item.sExtendType === 'date'">
                                            <span>{{ item.optionValue }}</span>
                                        </div>
                                        <div v-if="item.sExtendType === 'radio'">
                                            <el-radio-group v-model="item.optionValue" :disabled="disableType">
                                                <el-radio v-for="(op, i) in item.sParam.split(',')" :key="i" :label="op" :value="op"></el-radio>
                                            </el-radio-group>
                                        </div>
                                        <div v-if="item.sExtendType === 'checkbox'">
                                            <el-checkbox v-model="item.optionValue" :label="item.sParam" :disabled="disableType">{{ item.sParam }}</el-checkbox>
                                        </div>
                                        <div v-if="item.sExtendType === 'checkboxgroup'">
                                            <el-checkbox-group v-model="item.optionValue" :disabled="disableType">
                                                <el-checkbox v-for="(op, i) in item.sParam.split(',')" :key="i" :label="op" style="width:100px;margin:5px 0 0 0;"></el-checkbox>
                                            </el-checkbox-group>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </div>
                        </el-row>
                    </el-row>
                </el-form>
            </el-tab-pane>
        </el-tabs>
        <span slot="footer">
            <td-button type="button" @click="userDetailDialogClose()">{{ $t('common.CLOSE') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import resourceApi from '../assets/api.js';
export default {
    props: ['title', 'dialogUserDetailVisible', 'editItem', 'sysFlg', 'appendToBody'],
    /*创建时初始化数据信息*/
    created() {
        this.formUserInfo.sId = this.editItem.userId;
        this.formUserInfo.roleList = this.editItem.roleId;
        this.basicTableData.length = 0;
        let basicLable = [this.$t('common.USERNAME'), this.$t('common.VALIDITY_TO'), this.$t('common.LOCK_STATE'), this.$t('userInfo.USER_LEVEL')];
        basicLable.forEach(lable => {
            let basicInfo = {};
            basicInfo.label = lable;
            this.basicTableData.push(basicInfo);
        });

        // 获取当前用户信息
        let param = {
            userId: this.formUserInfo.sId,
            sSysFlg: this.sysFlg,
            currentPage: 1,
            pageSize: 10
        };
        resourceApi.getUserIpList(JSON.stringify({ sId: this.formUserInfo.sId }), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserIpList', response.data.statusMessage);
                return;
            }
            let array = response.data.content;
            let arrIp = [];
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                arrIp.push(element.sIp);
            }
            this.ipTableData[0].lable = this.$t('common.IP_WHITE_LIST');
            this.ipTableData[0].value = arrIp.join(',');
        });
        resourceApi.getUserMacList(JSON.stringify({ sId: this.formUserInfo.sId }), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserMacList', response.data.statusMessage);
                return;
            }
            let array = response.data.content;
            let arrMac = [];
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                arrMac.push(element.sMac);
            }
            this.macTableData[0].lable = this.$t('common.MAC_WHITE_LIST');
            this.macTableData[0].value = arrMac.join(',');
        });

        //获取当前用户的时间白名单信息
        resourceApi.getUserTimeList(JSON.stringify({ sId: this.formUserInfo.sId }), response => {
            //处理失败信息
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserTimeList', response.data.statusMessage);
                return;
            }
            let array = response.data.content;
            let timeArray = [];
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                timeArray.push(element.sStartTime + ' 至 ' + element.sEndTime);
            }
            this.timeTableData[0].lable = this.$t('userInfo.TIME_WHITE_LIST');
            this.timeTableData[0].value = timeArray.join(',');
        });

        resourceApi.listUserInfos(param, response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getAllUsers', response.data.statusMessage);
                return;
            }
            let userInfo = response.data.content;
            if (userInfo.length > 0) {
                const element = userInfo[0];
                let basicValue = [];
                basicValue.push(element.userName);
                basicValue.push(this.formatDate(new Date(element.dtLimit * 1), 'yyyy-MM-dd'));
                if (element.iLockType === 1) {
                    basicValue.push(this.$t('common.LOCK'));
                } else {
                    basicValue.push(this.$t('common.NORMAL'));
                }
                basicValue.push(this.editItem.iLevel);
                for (let i = 0; i < this.basicTableData.length; i++) {
                    this.basicTableData[i].lable = basicLable[i];
                    this.basicTableData[i].value = basicValue[i];
                }
                if (element.roleName) {
                    this.roleArray = element.roleName.split(',');
                }
            }
        });
        // 获取组织角色
        let paramOrgInfo = {
            sId: this.formUserInfo.sId,
            sysID: this.sysFlg,
            orgFlg: 1
        };

        resourceApi.getUserRoleInfo(JSON.stringify(paramOrgInfo), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserRoleInfo', response.data.statusMessage);
                return;
            }
            let array = response.data.content;
            for (let index = 0; index < array.length; index++) {
                this.checkedOrgList.push(array[index].sName);
            }
        });
        //门禁权限组
        let doorRoleQueryParam = {
            sId: this.formUserInfo.sId,
            sysFlg: this.sysFlg,
            orgFlg: 2
        };
        resourceApi.getUserRole(JSON.stringify(doorRoleQueryParam), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserRole', response.data.statusMessage);
                return;
            }
            let array = response.data.content;
            if (array.length > 0) {
                this.doorAuthList = array[0].sName.split(',');
            }
        });
        // 获取权限列表
        let paramAuthInfo = {
            sId: this.formUserInfo.sId,
            roleList: this.formUserInfo.roleList,
            sysID: this.sysFlg
        };

        resourceApi.getUserAuthInfo(JSON.stringify(paramAuthInfo), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserAuthInfo', response.data.statusMessage);
                return;
            }
            let array = response.data.content;
            let permissions = [];
            let auths = [];
            for (let index = 0; index < array.length; index++) {
                permissions.push(array[index].resTypeName);
                auths.push(array[index].authName);
            }
            let arrAuthStr = [];
            let temp = '';
            for (let index = 0; index < permissions.length; index++) {
                if (temp.indexOf(permissions[index]) === -1) {
                    if (temp !== '') {
                        arrAuthStr.push(temp);
                    }
                    temp = permissions[index] + '：' + auths[index];
                } else {
                    temp += '，' + auths[index];
                }
            }
            if (temp !== '') arrAuthStr.push(temp);
            this.authInfoData.length = 0;
            if (arrAuthStr) {
                arrAuthStr.forEach(authInfo => {
                    let authArray = authInfo.split('：');
                    let auth = {};
                    auth.lable = authArray[0];
                    auth.value = authArray[1];
                    this.authInfoData.push(auth);
                });
            }
        });

        // 获取用户扩展信息
        resourceApi.getUserExtends({ sysFlg: this.sysFlg }, response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserExtends', response.data.statusMessage);
                return;
            }
            let data = response.data.content;
            this.userExtends = data;
            // 为编辑状态则进行初始化数据
            let content = {
                sId: this.formUserInfo.sId,
                sysFlg: this.sysFlg
            };

            resourceApi.getUserExtendsValues(JSON.stringify(content), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getUserExtendsValues', response.data.statusMessage);
                    return;
                }

                let values = response.data.content;
                if (values.length == 0) {
                    return;
                }
                let i = 0;
                this.userExtends.forEach(v => {
                    v.extendList.forEach(val => {
                        if (val.sExtendType === 'checkboxgroup') {
                            if (values[i]) {
                                let arr = values[i].sValue.split('|');
                                val.optionValue = arr;
                            }
                        } else if (val.sExtendType === 'checkbox') {
                            if (values[i]) {
                                let arr = values[i].sValue === 'true';
                                val.optionValue = arr;
                            }
                        } else if (val.sExtendType === 'date') {
                            if (values[i]) {
                                val.optionValue = this.timeExchange(values[i].sValue);
                            }
                        } else {
                            if (values[i]) {
                                val.optionValue = values[i].sValue;
                            }
                        }
                        i++;
                    });
                });
            });
        });
        this.refBtnQuery();
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.noData = 'auth/' + window.vue.$store.state.skin + '/img/noData.png';
    },
    // 定义数据
    data() {
        return {
            noData: '',
            date: '',
            authInfoData: [],
            doorAuthList: [],
            refTableData: [],
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            columns: [
                {
                    prop: 'resName',
                    label: this.$t('userInfo.REF_NAME'),
                    minWidth: '30%'
                },
                {
                    prop: 'resTypeName',
                    label: this.$t('common.TYPE'),
                    minWidth: '28%'
                },
                {
                    prop: 'authName',
                    label: this.$t('userInfo.OPERATION_TYPE_TUNING'),
                    minWidth: '42%'
                }
            ],
            formHaveAuthRef: {
                refName: ''
            },
            roleArray: [],
            activeName: 'first',
            basicTableData: [],
            macTableData: [
                {
                    label: this.$t('common.MAC_WHITE_LIST'),
                    value: ''
                }
            ],
            ipTableData: [
                {
                    label: this.$t('common.IP_WHITE_LIST'),
                    value: ''
                }
            ],
            //登录时间白名单信息
            timeTableData: [
                {
                    label: this.$t('userInfo.TIME_WHITE_LIST'),
                    value: ''
                }
            ],
            formUserInfo: {
                sId: '',
                roleList: ''
            },
            disableType: true,
            userExtends: [],
            checkedOrgList: [],
            formLabelWidth: '30%'
        };
    },
    computed: {},
    // 方法的实现
    methods: {
        handleClick(tab, event) {
            //点击第五个tab页时为表格重新布局
            if (tab.index == '3') {
                this.$nextTick(function() {
                    this.$refs.refTable.doLayout();
                });
            }
        },
        timeExchange(timestamp) {
            const date = new Date(timestamp);
            const Y = date.getFullYear() + '-';
            const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            const D = date.getDate() + ' ';
            const dateString = Y + M + D;
            return dateString;
        },
        refBtnQuery() {
            let param = {
                userId: this.editItem.userId,
                resName: this.formHaveAuthRef.refName,
                currentPage: this.currentPage,
                pageSize: this.pageSize
            };
            resourceApi.queryFinetuneInfo(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/queryFinetuneInfo', response.data.statusMessage);
                    return;
                }
                if (this.$util.isEmpty(response.data.content) || !response.data.content.resultlist) {
                    return;
                }
                let resultlist = response.data.content.resultlist;
                resultlist.forEach(result => {
                    let authName = '';
                    if (result.authNameList.length == 0) {
                        authName = this.$t('userInfo.THE_SAME_OF_USERAUTH');
                    } else {
                        for (let i = 0; i < result.authNameList.length; i++) {
                            authName += result.authNameList[i] + ',';
                        }

                        if (authName.length > 0) {
                            authName = authName.substr(0, authName.length - 1);
                        }
                    }
                    result.authName = authName;
                });
                this.refTableData = resultlist;
                this.total = response.data.content.total;
            });
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.queryPageList();
        },
        queryPageList() {
            this.currentPage = 1;
            this.refBtnQuery();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.refBtnQuery();
        },
        blue({ row, column, rowIndex, columnIndex }) {
            if (columnIndex == 0) {
                return 'blue';
            }
        },
        userDetailDialogClose() {
            this.$emit('userDetailDialogClose');
        },
        formatDate(date, fmt) {
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
            }
            let o = {
                'M+': date.getMonth() + 1,
                'd+': date.getDate(),
                'h+': date.getHours(),
                'm+': date.getMinutes(),
                's+': date.getSeconds()
            };
            for (let k in o) {
                if (new RegExp(`(${k})`).test(fmt)) {
                    let str = o[k] + '';
                    fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length));
                }
            }
            return fmt;
        }
    }
};
</script>
<style scoped>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
>>> .el-tabs__header {
    margin: 20px 0 10px !important;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
.blue {
    background: rgb(247, 249, 247);
}
.authTable {
    border-collapse: collapse;
    margin: 0 auto;
    text-align: center;
}
.authMsg >>> .el-col .el-form-item .el-form-item__label{
    width: auto !important;
}
</style>
